import { ShowHideButton } from './show-hide-button';
import { ShowHideHidden } from './show-hide-hidden';
import { ShowHideRoot } from './show-hide-root';

/**
 * Entry point for ShowHide.Root, ShowHide.Hidden, and ShowHide.Button
 *
 * @since 8.36.0
 */

export const ShowHide = {
  Root: ShowHideRoot,
  Hidden: ShowHideHidden,
  Button: ShowHideButton,
};
